export default function InvoiceTab() {
  return <div>Invoice Tab</div>;
}
